import axios from "axios";
import { geoServerBaseUrl } from "./baseUrl";
import sort_array from "./../../App/validation/sort_array";
import { calculateWithoutConvert } from "../validation/convert_data";
import get_relasi_kai from "../validation/get_relasi_kai";
import get_hour_kai from "../validation/get_hour_kai";
import get_year_kai from "../validation/get_year_kai";
import get_biop_kai from "../validation/get_biop_kai";
import get_year_kai_pendapatan_non_farebox from "../validation/get_year_kai_pendapatan_non_farebox";
import get_kai_net_cash_flow from "../validation/get_kai_net_cash_flow";
import { bun_server } from "./baseUrl";
import { setLoading } from "./crudNestedTable";
import { clearLoading } from "./crudNestedTable";
import { post_activities } from "./activities";

const SERVER_URL = geoServerBaseUrl;
const stop = 100_000;

// const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const calculate_time_delta = (date) => {
  const now = Date.now();
  // OPTIMIZATION: Use Date.parse() instead of new Date().getTime() to prevent massive object allocation in RAM
  const feature_date = date ? Date.parse(date) || 0 : 0;
  const delta_ms = now - feature_date;
  let remaining_days = Math.floor(delta_ms / (1000 * 60 * 60 * 24));
  const years_count = Math.floor(remaining_days / 365);

  remaining_days -= years_count * 365;
  const months_count = Math.floor(remaining_days / 30);
  remaining_days -= months_count * 30;
  return {
    years_count,
    months_count,
    days_count: remaining_days,
  };
};

const sort_features = (
  features,
  sorted_field,
  sorted_mode,
  sorted_field_type,
) => {
  if (!sorted_field) return features;
  return [...features].sort((a, b) => {
    if (sorted_field_type === "date") {
      // OPTIMIZATION: Date.parse returns an integer (timestamp) requiring 0 memory allocations
      const date_a = a.properties[sorted_field]
        ? Date.parse(a.properties[sorted_field]) || 0
        : 0;
      const date_b = b.properties[sorted_field]
        ? Date.parse(b.properties[sorted_field]) || 0
        : 0;
      return sorted_mode === "asc" ? date_a - date_b : date_b - date_a;
    }
    const value_a = a.properties[sorted_field];
    const value_b = b.properties[sorted_field];
    if (value_a == null && value_b == null) return 0;
    if (value_a == null) return sorted_mode === "asc" ? 1 : -1;
    if (value_b == null) return sorted_mode === "asc" ? -1 : 1;
    if (sorted_field_type === "number") {
      const num_a = Number(value_a);
      const num_b = Number(value_b);
      return sorted_mode === "asc" ? num_a - num_b : num_b - num_a;
    }
    const str_a = String(value_a).toLowerCase();
    const str_b = String(value_b).toLowerCase();
    return sorted_mode === "asc"
      ? str_a.localeCompare(str_b)
      : str_b.localeCompare(str_a);
  });
};

// New function to sort by date_in
const sort_features_by_date_in = (features, sorted_mode) => {
  return [...features].sort((a, b) => {
    // OPTIMIZATION: Avoid millions of Date objects during sort comparisons
    const date_a = a.date_in ? Date.parse(a.date_in) || 0 : 0;
    const date_b = b.date_in ? Date.parse(b.date_in) || 0 : 0;
    return sorted_mode === "asc" ? date_a - date_b : date_b - date_a;
  });
};

//Get Layer By id layer
export const getDetailLayerById = (content) => async (dispatch) => {
  try {
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "legend_site_selection",
        value: false,
      },
    });
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "legend_status",
        value: false,
      },
    });

    const {
      geo_project_id,
      geo_layer_id,
      is_ignore_set_layer_id,
      folder_id,
      capex_value,
      geo_layer_item,
      skipLoading,
      tableStatus,
      geometryStatus,
      flyStatus,
    } = content;
    const { is_custom_endpoint } = geo_layer_item || {};

    if (geo_layer_id) {
      dispatch(
        post_activities({
          action: "open_layer",
          layer_id: geo_layer_id,
        }),
      );
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      if (!skipLoading) {
        dispatch(setLoading("get_detail"));
      }

      const res = await axios.get(
        bun_server +
          `/moneys_bun/get_layer_detail_by_id/${geo_layer_id}/${geo_project_id}`,
        config,
      );
      let geo_layer = res.data || {};

      //pengecekan apakah ada data pembanding atau tidak, jika ada akan dilakukan get data pembanding
      const id_pembanding = geo_layer?.layer_data_list?.[0]?._id;
      let layer_pembanding = {};
      if (id_pembanding) {
        const features_appraisal = geo_layer?.geojson?.features || [];
        const geo_project_id = geo_layer?.layer_data_list?.[0]?.geo_project;
        const res = await axios.get(
          bun_server +
            `/moneys_bun/get_layer_detail_by_id/${id_pembanding}/${geo_project_id}?layer_parent=${geo_layer_id}`,
          config,
        );
        layer_pembanding = res?.data || {};

        if (layer_pembanding?._id) {
          const geo_layer_id = layer_pembanding?._id;
          let geojson_pembanding = layer_pembanding.geojson;
          let features_pembanding = geojson_pembanding?.features || [];
          const fields = layer_pembanding?.fields || [];

          features_pembanding = features_pembanding.map((feature) => {
            const feature_appraisal = features_appraisal.find((item) =>
              item.data_pembanding_list.includes(feature.key),
            );
            let features = [feature];
            if (feature_appraisal) {
              features = calculateWithoutConvert({
                features,
                fields,
                feature_appraisal,
              });
            }
            return { ...features[0], type: "Feature" };
          });
          geojson_pembanding.features = features_pembanding;
          const payload = { geo_layer_id, geojson: geojson_pembanding };
          dispatch({
            type: "REPLACE_GEOJSON",
            payload,
          });
        }
      }

      //pengecekan apakah ada field counting_custom
      const fields = res?.data?.fields || [];
      const fields_cc = fields.filter(
        (field) => field?.type === "counting_custom",
      );

      fields_cc.forEach((field) => {
        if (field?.custom_counting_id) {
          const body = {
            geo_project_id,
            geo_layer_id: field?.custom_counting_id,
            is_ignore_set_layer_id: true,
          };
          dispatch(getDetailLayerById(body));
        }
      });

      let geojson = geo_layer?.geojson || {};

      // PROSES READ FEATURE UNTUK ARCHITECTURE BARU V2
      if (res.data?.architecture === "v2") {
        geojson.features = [];
        // CUSTOM API
        if (is_custom_endpoint) {
          const config = {
            headers: {
              accesstoken: localStorage.token_mapid,
            },
          };
          const res = await axios.get(
            SERVER_URL +
              "/open_api/get_detail_layer_custom_endpoint/" +
              geo_layer_id,
            config,
          );
          geo_layer.fields = res.data?.fields;
          geojson.features.push(...res.data?.geojson?.features);
        }
        // DEFAULT V2
        else {
          const count = await axios.get(
            bun_server +
              `/moneys_bun/v2/get_layer_count_by_id/${geo_layer_id}/${geo_project_id}`,
            config,
          );

          const features_length = count.data;
          const limit = 100; // <-- Restored back to 100 to respect backend limits

          // OPTIMIZATION: PRE-ALLOCATE ARRAY
          // Defining exact array limits drastically cuts down on RAM usage and GC stuttering
          const max_features = Math.min(features_length, stop);
          geojson.features = new Array(max_features);

          // BATCHING PROMISES OPTIMIZATION
          const totalRequests = Math.ceil(max_features / limit);
          const CONCURRENCY_LIMIT = 1; // Adjust this higher if backend allows

          for (
            let batchStart = 0;
            batchStart < totalRequests;
            batchStart += CONCURRENCY_LIMIT
          ) {
            const batchPromises = [];

            for (let i = 0; i < CONCURRENCY_LIMIT; i++) {
              const requestIndex = batchStart + i;
              if (requestIndex >= totalRequests) break;

              const skip = requestIndex * limit;
              batchPromises.push(
                axios
                  .get(
                    bun_server +
                      `/moneys_bun/v2/get_layer_detail_by_id/${geo_layer_id}/${geo_project_id}?skip=${skip}&limit=${limit}`,
                    config,
                  )
                  .then((res) => ({ skip, dataChunk: res.data })),
              );
            }

            const currentSkip = Math.min(batchStart * limit, max_features);
            const progressPercent = Math.min(
              100,
              parseInt((currentSkip / features_length) * 100),
            );
            dispatch(
              setLoading(
                `Loading ${progressPercent}% ${currentSkip}/${features_length}`,
              ),
            );

            // Wait for all concurrent requests in this batch to finish
            const batchResults = await Promise.all(batchPromises);

            for (const result of batchResults) {
              const { skip, dataChunk } = result;
              const chunkLength = dataChunk.length;

              // OPTIMIZATION: DIRECT ASSIGNMENT
              // Avoids Maximum Call Stack limits and memory array cloning
              for (let i = 0; i < chunkLength; i++) {
                if (skip + i < max_features) {
                  geojson.features[skip + i] = dataChunk[i];
                }
              }
            }

            // await delay(10);
          }

          // Truncate length just in case the backend delivered fewer rows than initially counted
          // Filter out the empty slots
          geojson.features = geojson.features.filter(
            (item) => item !== undefined,
          );
        }
      }

      if (geo_layer?._id) {
        const fields = geo_layer?.fields || [];
        let features = geojson?.features || [];

        // OPTIMIZATION: In-place object configuration instead of .map() chains
        // This removes 100k+ intermediate object arrays from hitting your RAM limits.
        for (let i = 0; i < features.length; i++) {
          let feature = features[i];
          if (!feature.properties) feature.properties = {};
          feature.properties.key = feature.key;
          feature.type = "Feature";
          feature.id = i;
        }

        // OPTIMIZATION: Avoided another full array map for children arrays
        for (let i = 0; i < features.length; i++) {
          let feature_parent = features[i];
          let child_array = feature_parent?.child_array || [];

          if (child_array.length > 0) {
            for (let j = 0; j < child_array.length; j++) {
              const item = child_array[j];
              const fields_child = fields.filter(
                (field) => field.parent_uuid === item.parent_uuid,
              );
              const result = calculateWithoutConvert({
                features: [item],
                fields: fields_child,
                feature_parent,
                source: "fetch_data_first_child",
              });
              child_array[j] = result[0];
            }
          }
          feature_parent.child_array = child_array;
        }

        let features_final = calculateWithoutConvert({
          features: features, // Pass the efficiently mutated base array
          fields,
          source: "fetch_data_first",
          capex_value,
        });

        // OPTIMIZATION: Object.assign skips making deep clones for simple combinations
        for (let i = 0; i < features_final.length; i++) {
          Object.assign(
            features_final[i],
            calculate_time_delta(features_final[i].date_in),
          );
        }

        geojson.features = features_final;

        //generate chart untuk beberapa type data timeseries dari KAI
        //CASE 1
        if (geo_layer?.timeseries_object?.timeseries_mode === "kai") {
          const relasi_list = get_relasi_kai(geo_layer);
          const hour_list = get_hour_kai(geo_layer);
          geo_layer.relasi_list = relasi_list?.relasi_array_of_object;
          geo_layer.max_penumpang = relasi_list?.max_penumpang;
          geo_layer.hour_list = hour_list;
          if (folder_id) {
            dispatch({
              type: "set_folder_timeseries_kai",
              payload: {
                geo_layer_id: geo_layer_id,
                folder_id,
                max_penumpang: relasi_list.max_penumpang,
                max_passenger: relasi_list.max_passenger,
                max_train: relasi_list.max_train,
              },
            });
          }
        }
        //CASE 2
        else if (
          geo_layer?.timeseries_object?.timeseries_mode === "kai_income_farebox"
        ) {
          const relasi_list = get_relasi_kai(geo_layer);
          geo_layer.relasi_list = relasi_list?.relasi_array_of_object;
        }
        //CASE 3
        else if (geo_layer?.timeseries_object?.timeseries_mode === "kai_biop") {
          const chart_js_data_biop = get_biop_kai(geo_layer);
          geo_layer.chart_js_data_biop = chart_js_data_biop;
        }
        //CASE 4
        else if (
          geo_layer?.timeseries_object?.timeseries_mode ===
          "kai_komponen_pendapatan_tiket"
        ) {
          const timeseries_komponen_array = get_year_kai(geo_layer);
          geo_layer.timeseries_komponen_array = timeseries_komponen_array;
        }
        //CASE 5
        else if (
          geo_layer?.timeseries_object?.timeseries_mode ===
          "kai_pendapatan_non_farebox"
        ) {
          const timeseries_komponen_array =
            get_year_kai_pendapatan_non_farebox(geo_layer);
          geo_layer.timeseries_komponen_array = timeseries_komponen_array;
        } //CASE 6
        else if (
          geo_layer?.timeseries_object?.timeseries_mode === "kai_net_cash_flow"
        ) {
          const chart_js_data_net_cash_flow = get_kai_net_cash_flow(geo_layer);
          geo_layer.chart_js_data_net_cash_flow = chart_js_data_net_cash_flow;
        }
        let geojson_filtered = { ...geojson };

        let features_sorted = sort_array(features_final, "idx", true);

        const side_table_object = geo_layer?.side_table_object;

        //manipulasi untuk keperluan sort by database (banjir & non banjir)
        if (side_table_object?.sorted_number) {
          const { sorted_field, sorted_number, sorted_mode } =
            side_table_object;

          if (sorted_field) {
            const sorted_field_object = fields.find(
              (item) => item.key === sorted_field,
            );
            const sorted_field_type = sorted_field_object?.type || "text";
            features_sorted = sort_features(
              features_sorted,
              sorted_field,
              sorted_mode,
              sorted_field_type,
            );
            if (sorted_field_type === "date") {
              // OPTIMIZATION: Object.assign instead of spreading
              for (let i = 0; i < features_sorted.length; i++) {
                Object.assign(
                  features_sorted[i],
                  calculate_time_delta(
                    features_sorted[i].properties[sorted_field],
                  ),
                );
              }
            }
          } else {
            // Sort by feature.date_in
            features_sorted = sort_features_by_date_in(
              features_sorted,
              sorted_mode,
            );
            // Calculate time delta for date_in
            for (let i = 0; i < features_sorted.length; i++) {
              Object.assign(
                features_sorted[i],
                calculate_time_delta(features_sorted[i].date_in),
              );
            }
          }

          geo_layer.geojson.features = features_sorted;

          if (side_table_object?.is_show_all === "no") {
            features_sorted = features_sorted.slice(0, Number(sorted_number));
          }
        }

        geojson_filtered.features = features_sorted;
        geo_layer.geojson_filtered = geojson_filtered;

        const payload = {
          geo_layer_item: geo_layer,
          content,
          is_ignore_set_layer_id,
        };
        dispatch({
          type: "GET_LAYER_DETAIL",
          payload: payload,
        });

        //get data banjir setelah set ke layer supaya tidak tertimpa
        if (side_table_object?.type_2 === "banjir") {
          const res = await axios.get(
            bun_server +
              `/sini_v2/ss_formula/get_list_features_flood?point_flood_layer_id=${geo_layer_id}`,
            config,
          );
          const data = res?.data || [];

          dispatch({
            type: "set_inside_geo_layer",
            payload: {
              geo_layer_id,
              key: "features_flood_all",
              value: data,
            },
          });

          let polygon_flood_feature_key_array = [];
          features_final.forEach((item) => {
            if (item?.properties?.polygon_flood_feature_key)
              polygon_flood_feature_key_array.push(
                item?.properties?.polygon_flood_feature_key,
              );
          });

          dispatch({
            type: "genangan_update",
          });
        }

        if (!is_ignore_set_layer_id) {
          dispatch({
            type: "fly_action",
          });
        }
        if (tableStatus !== undefined) {
          dispatch({
            type: "SET_TABEL_STATUS",
            payload: tableStatus,
          });
        } else if (geometryStatus !== undefined) {
          dispatch({
            type: "SET_GEOMETRY_STATUS",
            payload: geometryStatus,
          });
        } else if (flyStatus !== undefined) {
          dispatch({
            type: "SET_FLY_STATUS",
            payload: flyStatus,
          });
        }
        dispatch(clearLoading());
        dispatch({
          type: "fly_action",
        });
      }

      dispatch({
        type: "status_action",
      });
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "legend_site_selection",
          value: true,
        },
      });
      dispatch({
        type: "set_value_properties",
        payload: {
          key: "legend_status",
          value: true,
        },
      });
    }
  } catch (error) {
    dispatch(clearLoading());
  }
};
